import React, { useEffect } from 'react';
import SignupFormContainer from "../containers/SignupForm";

const SignupForm: React.FC= () => {

  useEffect(() => {
    document.title = 'Elite Community CU | Become A Member';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "Fill our resgistration form and become and elite banker in minutes...";
    document.head.appendChild(metaDescription);
  }, []);

  return (
    <div>
      <SignupFormContainer />
    </div>
  );
};

export default SignupForm;
























// import React, { useEffect } from "react";
// import '../css/BecomeMemberForm.css'

// const BecomeMemberForm: React.FC= () => {

//     useEffect(()=>{
//       document.title = 'Elite Community Credit Union -- Secure Services Application'
//     }, [])
  
//     return (
//       <div style={{maxWidth: '90vw', margin: '0 auto'}}>
//         <div style={{height: '10px'}}></div>
//         <table className="become-member-form-table" border={0} align="center" cellPadding={0} cellSpacing={0}>
//             <tbody>
//               <tr> 
//                 <td className="become-member-form-tb-253">
//                   <a href="/">
//                     <img src="/imgs/tlogo.gif" alt="Home Page" className="become-member-form-img" />
//                   </a>
//                 </td>

//                 <td className="become-member-form-tb-text">
//                   <strong><h1><span className="header">SECURE CU SERVICES SIGN UP FORM</span></h1>
//                     515 S. Main Street
//                     Bourbonnais, IL 60914<br />
//                     Phone: (815) 933-7711&nbsp; •&nbsp; Fax: (815) 933-5802</strong>
//                   </td>
//               </tr>
//             </tbody>
//         </table>



//         <table className="become-member-form-table" border={0} align="center" cellPadding={0} cellSpacing={0}>
//             <tbody>
//               <tr>
//                 <td className="become-member-form-tb-253">

//                     <div className="become-member-form-hr"></div>


//                     <div className="become-member-form-tb" style={{marginTop: '1.5rem'}}>SERVICES<img src="/imgs/da.gif" alt="" className="become-member-form-tb-icon" /></div>

//                       <table className="become-member-form-table-style2">
//                         <tbody>
//                             <tr style={{background: 'rgb(255, 252, 235)'}}> 
//                               <td className="become-member-form-td-style2"> 


//                                 <div style={{textAlign: 'left', padding: '10px'}}>
//                                   <strong> I Am Applying For The Following Services:<br />
//                                     <input name="mbr" aria-label="mbr" type="checkbox" id="mbr" value="mbr" className="become-member-form-input"/>
//                                   </strong> Membership<strong><br />

//                                   <input name="obb" aria-label="obb" type="checkbox" id="obb" value="obb" className="become-member-form-input"/>
//                                   </strong> Online Account Access (Access your account on the Internet)<br />
//                                   <input name="est" aria-label="est" type="checkbox" id="est" value="est" className="become-member-form-input"/>
//                                   eStatements (Get your statements via email) By submitting this 
//                                   request, I acknowledge that I have read and agree to the terms 
//                                   of the <a href="agreefrag.html" target="_blank" className="become-member-form-link">Online eStatement 
//                                   Disclosure</a> 
//                                   <input type="checkbox" aria-label="checkbox" name="agree" checked className="become-member-form-input"/> 
//                                   <br />
//                                   <input name="dc" aria-label="dc" type="checkbox" id="dc" value="dc" className="become-member-form-input"/>
//                                   Debit Card<br />
//                                   <input name="atm" aria-label="atm" type="checkbox" id="atm" value="atm" className="become-member-form-input"/>
//                                   ATM Access Card<br />
//                                   Increase in your credit card line of credit by:<br />
//                                   <input name="loc1" aria-label="loc1" type="checkbox" id="loc1" value="loc1" className="become-member-form-input"/>
//                                   $1,000.00<br />
//                                   <input name="loc2" aria-label="loc2" type="checkbox" id="loc2" value="loc2" className="become-member-form-input"/>
//                                   $2,000.00<br />
//                                   <input name="loc3" aria-label="loc3" type="checkbox" id="loc3" value="loc3" className="become-member-form-input"/>
//                                   $3,000.00<br />
//                                   <input name="loc4" aria-label="loc4" type="checkbox" id="loc4" value="loc4" className="become-member-form-input"/>
//                                   Other 
//                                   <input name="svc_other" aria-label="svc_other" type="text" id="svc_other" className="become-member-form-input-style2"/>
//                                 </div>


//                               </td>
//                             </tr>
//                         </tbody>
//                       </table>




                      
                      
                      
//                       <div className="become-member-form-tb" style={{marginTop: '1.5rem'}}>PERSONAL INFORMATION<img src="/imgs/da.gif" alt="" className="become-member-form-tb-icon" /></div>


//                       <table className="become-member-form-table-style2">
//                         <tbody>
//                             <tr style={{background: 'rgb(255, 252, 235)'}}> 
//                               <td className="become-member-form-td-style2"> 

//                                 <div style={{textAlign: 'left', padding: '10px'}}>
//                                   <table className="become-member-form-table-style3">
//                                         <tbody className="become-member-form-tbody-style3">
//                                           <tr className="become-member-form-tr-style3"> 
//                                             <td className="become-member-form-td-style3"> 
//                                               <table className="become-member-form-table-style3">
//                                                   <tbody className="become-member-form-tbody-style3">
//                                                     <tr> 
//                                                       <td className="become-member-form-td-style4"> <div style={{textAlign: 'right'}}>First Name: </div></td>
//                                                       <td className="become-member-form-td-style5"> <input style={{margin: '3px 3px 3px 3px'}} name="firstname" aria-label="firstname" type="text" id="firstname5" /> 
//                                                       </td>
//                                                     </tr>
//                                                     <tr> 
//                                                       <td><div style={{textAlign: 'right'}}>Home Address: </div></td>
//                                                       <td><input style={{margin: '3px 3px 3px 3px'}} name="add" aria-label="add" type="text" id="add3" /></td>
//                                                     </tr>
//                                                     <tr> 
//                                                       <td><div style={{textAlign: 'right'}}>Apt./Suite #: </div></td>
//                                                       <td><input style={{margin: '3px 3px 3px 3px'}} name="apt" aria-label="apt" type="text" id="apt3" /></td>
//                                                     </tr>
//                                                     <tr> 
//                                                       <td><div style={{textAlign: 'right'}}>City: </div></td>
//                                                       <td><input style={{margin: '3px 3px 3px 3px'}} name="city" aria-label="city" type="text" id="city3" /></td>
//                                                     </tr>
//                                                     <tr> 
//                                                       <td><div style={{textAlign: 'right'}}>State: </div></td>
//                                                       <td><input style={{margin: '3px 3px 3px 3px'}} name="state" aria-label="state" type="text" id="state3" /></td>
//                                                     </tr>
//                                                     <tr> 
//                                                       <td><div style={{textAlign: 'right'}}>Zip: </div></td>
//                                                       <td><input style={{margin: '3px 3px 3px 3px'}} name="zip" aria-label="zip" type="text" id="zip3" /></td>
//                                                     </tr>
//                                                   </tbody>
//                                               </table>
//                                             </td>




//                                             <td className="become-member-form-td-style3"> 
//                                               <table className="become-member-form-table-style3">
//                                                 <tbody className="become-member-form-tbody-style3">
//                                                   <tr> 
//                                                     <td className="become-member-form-td-style4"><div style={{textAlign: 'right'}}>Last Name:</div></td>
//                                                     <td className="become-member-form-td-style5"><input style={{margin: '3px 3px 3px 3px'}} name="lastname" aria-label="lastname" type="text" id="lastname3"/> 
//                                                     </td>
//                                                   </tr>
//                                                   <tr> 
//                                                     <td><div style={{textAlign: 'right'}}>Daytime Phone:</div></td>
//                                                     <td><input style={{margin: '3px 3px 3px 3px'}} name="dayphone" aria-label="dayphone" type="text" id="dayphone"/></td>
//                                                   </tr>
//                                                   <tr> 
//                                                     <td><div style={{textAlign: 'right'}}>Email Address:</div></td>
//                                                     <td><input style={{margin: '3px 3px 3px 3px'}} name="email" aria-label="email" type="text" id="email"/></td>
//                                                   </tr>
//                                                   <tr> 
//                                                     <td><div style={{textAlign: 'right'}}>Social Security #:</div></td>
//                                                     <td><input style={{margin: '3px 3px 3px 3px'}} name="social" aria-label="social" type="text" id="social"/></td>
//                                                   </tr>
//                                                   <tr> 
//                                                     <td><div style={{textAlign: 'right'}}>Account #: </div></td>
//                                                     <td><input style={{margin: '3px 3px 3px 3px'}} name="acctnum" aria-label="acctnum" type="text" id="acctnum"/></td>
//                                                   </tr>
//                                                   <tr> 
//                                                     <td><div style={{textAlign: 'right'}}>Date of Birth:</div></td>
//                                                     <td><input style={{margin: '3px 3px 3px 3px'}} name="dob" aria-label="dob" type="text" id="dob"/></td>
//                                                   </tr>
//                                                 </tbody>
//                                               </table>
//                                             </td>
//                                           </tr>



//                                           <tr> 
//                                             <td valign="top">&nbsp;</td>
//                                             <td valign="top">&nbsp;</td>
//                                           </tr>
//                                           <tr> 
//                                             <td colSpan={2} valign="top">Additional Comments:<br /> <textarea name="comments" aria-label="comments" cols={60} rows={6} id="comments"></textarea> 
//                                             </td>
//                                           </tr>
//                                           <tr>
//                                             <td colSpan={2} valign="top">&nbsp;</td>
//                                           </tr>
//                                       </tbody>
//                                   </table>
//                                 </div>


//                               </td>
//                             </tr>
//                         </tbody>
//                       </table>
//                 </td>
//               </tr>
//             </tbody>
//           <div style={{height: '10px'}}></div>
//           <p className="become-member-form-p">By submitting this application, I authorize Elite Community Credit Union to obtain a credit bureau report, if necessary to determine credit worthiness.</p>
//           <div style={{height: '30px'}}></div>
          


//             <div style={{textAlign: 'center'}}> 
//               <input name="button" type="button" value="Submit Form" className="become-member-form-button"/>
//               <input name="reset" type="reset" value="Erase Form" className="become-member-form-button"/>
//             </div>
//             <div style={{height: '20px'}}></div>







          
//         </table>
//       </div>
//     )
//   }
  
//   export default BecomeMemberForm